<template>
    <div>
        <b-row class="bgray-200 fw-400 w-100 mb-0 px-3 py-3" no-gutters align-v="center">
            <b-col cols="12" md="3">
                <b-button
                    variant="icon"
                    class="mb-0 mb-md-2"
                    @click="moveToCampaignListPage"
                    :disabled="is_saving_campaign"
                    small
                    >
                    &lang; <span class="pl-2">목록으로 이동</span>
                </b-button>
            </b-col>
            <b-col cols="12" md="6">
                <h2 class="py-5 fw-400 text-center mb-0"> EDIT CAMPAIGN </h2>
            </b-col>
        </b-row>
        

        <b-container class="py-5">
            <b-row>
                <b-col cols="12">
                    <b-form @submit.prevent="handleSaveCampaign">
                        <b-form-row>
                            <b-col cols="12" md offset-md="auto" class="text-right">
                                <b-btn
                                    type="submit"
                                    :variant="is_saving_campaign === true ? 'green' : 'blue'"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_edited_campaign"
                                    size="sm"
                                    class="mr-2"
                                    >
                                    <span v-show="is_saving_campaign">
                                        <b-spinner class="mx-2 p-1 my-1" small type="grow"></b-spinner> 저장 중입니다.
                                    </span>
                                    <span v-show="!is_saving_campaign">
                                        평가 저장하기 <fa icon="save" class="ml-2"></fa>
                                    </span>
                                </b-btn>
                                <b-btn
                                    variant="danger"
                                    @click="resetCampaign"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_edited_campaign"
                                    size="sm"
                                    class="mr-2"
                                    >
                                    되돌리기
                                </b-btn>
                                <b-btn
                                    @click="initializeCampaignTranslation(null)"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_able_to_translation_intial"
                                    size="sm"
                                    >
                                    전체 번역 초기화
                                    <b-spinner v-show="is_initializing_campaign_translation" class="mr-1" />
                                </b-btn>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="9" offset-md="3">
                                <hr class="border-top-0 border-bottom border-color-gray-700 pt-0 mb-3 mt-0">
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="3">
                                <h4 class="">1. 필수요소</h4>
                            </b-col>
                            <b-col cols="12" md="9">
                                <b-form-row class="mb-3">
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-name"
                                            label="평가 캠페인 명"
                                            label-for="input-campaign-name"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-input
                                                id="input-campaign-name"
                                                type="text"
                                                v-model="temp_campaign.campaign_name"
                                                placeholder="평가 캠페인 명"
                                                @input="editCampaign('campaign_name')"
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                required
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-name"
                                            label="(영문) 평가 캠페인 명"
                                            label-for="input-campaign-name-ea"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-input
                                                id="input-campaign-name-ea"
                                                type="text"
                                                v-model="temp_campaign.campaign_name_e"
                                                @input="editCampaign('campaign_name_e')"
                                                :placeholder="!campaign.campaign_name_e ? '번역된 영/중문이 있을시 수정 가능' : '(영문) 평가 캠페인 명'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.campaign_name_e)"
                                                required
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-name"
                                            label="(중문) 평가 캠페인 명"
                                            label-for="input-campaign-name-ca"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-input
                                                id="input-campaign-name-ca"
                                                type="text"
                                                v-model="temp_campaign.campaign_name_c"
                                                @input="editCampaign('campaign_name_c')"
                                                :placeholder="!campaign.campaign_name_c ? '번역된 영/중문이 있을시 수정 가능' : '(중문) 평가 캠페인 명'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.campaign_name_c)"
                                                required
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" class="text-right">
                                        <b-btn
                                            variant="dark-border"
                                            size="sm"
                                            @click="initializeCampaignTranslation('campaign_name')"
                                            :disabled="getGlobalDisabledCampaignEdit || value_new || isFieldEmpty(campaign.campaign_name)"
                                            >
                                            캠페인명 - 번역 초기화
                                        </b-btn>
                                    </b-col>
                                </b-form-row>
                                <b-form-row>
                                    <b-col cols="12" md="4" class="mb-3 mb-md-0">
                                        <b-form-group
                                            id="input-group-campaign-period"
                                            label="기간 및 회차"
                                            label-for="input-campaign-period"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-select
                                                id="input-campaign-period"
                                                v-model="selected_period"
                                                @change="editCampaign('selected_period')"
                                                :options="period_options"
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                required
                                                />
                                                <!-- style="max-width:150px;" -->
                                        </b-form-group>
                                        <div class="f-90 gray-550">참여기간: {{ start_date }} ~ {{ end_date }}</div>
                                        <div class="f-90 gray-550">데이터 target : {{ target_year }}</div>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-industry"
                                            label="평가 산업"
                                            label-for="input-campaign-industry"
                                            label-class="fw-500 f-110"
                                            description="산업명 또는 산업코드를 검색해 해당되는 산업을 선택해주세요."
                                            >
                                            <b-form-input
                                                id="input-campaign-industry"
                                                list="my-list-id"
                                                v-model="selected_industry"
                                                @input="editCampaign('selected_industry')"
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                >
                                            </b-form-input>
                                            <b-form-datalist
                                                id="my-list-id"
                                                :options="industry_options"
                                                >
                                            </b-form-datalist>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-onsite-audit"
                                            label="실사 여부"
                                            label-for="input-campaign-onsite-audit"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-checkbox
                                                id="input-campaign-onsite-audit"
                                                v-model="temp_campaign.process_options"
                                                value="현장실사"
                                                @change="editCampaign('process_options')"
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                required
                                                >
                                                현장실사
                                            </b-form-checkbox> 
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-block-unanswered"
                                            label="제출 옵션"
                                            label-for="input-campaign-block-unanswered"
                                            label-class="fw-500 f-110"
                                            description="켜면 활성화된 문항에 미답변이 있을 때 협력사의 최종 제출을 막습니다. (판정은 백엔드)"
                                            >
                                            <!-- value 문자열은 백엔드 DFCampaigns.process_options 와 공유하는 계약값 -->
                                            <b-form-checkbox
                                                id="input-campaign-block-unanswered"
                                                v-model="temp_campaign.process_options"
                                                value="미답변제출차단"
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                @change="editCampaign('process_options')"
                                                >
                                                미답변 문항 제출 차단
                                            </b-form-checkbox>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="9" offset-md="3">
                                <hr class="border-top-0 border-bottom border-color-gray-700 pt-md-3 mb-5">
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="3">
                                <h4>2. 평가 기본정보</h4>
                            </b-col>
                            <b-col cols="12" md="9">
                                <b-form-row class="mb-5 mb-md-3">
                                    <b-col cols="12" md="4" class="mb-3 mb-md-0">
                                        <b-form-group
                                            id="input-group-campaign-introduction"
                                            label="평가 소개 문구"
                                            label-for="input-campaign-introduction"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-textarea v-if="description_preview !== true"
                                                id="input-campaign-introduction"
                                                v-model="temp_campaign.campaign_description"
                                                @input="editCampaign('campaign_description')"
                                                rows="8"
                                                class="mb-2"
                                                placeholder="평가 소개 문구를 작성해 주세요."
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                trim
                                                />
                                            <div v-if="description_preview === true"
                                                class="mb-2 py-3 px-3 bgray-200 rounded"
                                                v-html="isFieldEmpty(temp_campaign.campaign_description) ? '(없음)' : temp_campaign.campaign_description"
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4" class="mb-3 mb-md-0">
                                        <b-form-group
                                            id="input-group-campaign-introduction-e"
                                            label="(영문) 평가 소개 문구"
                                            label-for="input-campaign-introduction-e"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-textarea v-if="description_preview !== true"
                                                id="input-campaign-introduction-e"
                                                v-model="temp_campaign.campaign_description_e"
                                                @input="editCampaign('campaign_description_e')"
                                                rows="8"
                                                class="mb-2"
                                                :placeholder="!campaign.campaign_description_e ? '번역된 영/중문이 있을시 수정 가능' : '평가 소개 문구를 작성해 주세요.'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.campaign_description) || isFieldEmpty(campaign.campaign_description_e)"
                                                trim
                                                />
                                            <div v-if="description_preview === true"
                                                class="mb-2 py-3 px-3 bgray-200 rounded"
                                                v-html="isFieldEmpty(temp_campaign.campaign_description_e) ? '(없음)' : temp_campaign.campaign_description_e"
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-introduction-c"
                                            label="(중문) 평가 소개 문구"
                                            label-for="input-campaign-introduction-c"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-form-textarea v-if="description_preview !== true"
                                                id="input-campaign-introduction-c"
                                                v-model="temp_campaign.campaign_description_c"
                                                @input="editCampaign('campaign_description_c')"
                                                rows="8"
                                                class="mb-2"
                                                :placeholder="!campaign.campaign_description_c ? '번역된 영/중문이 있을시 수정 가능' : '평가 소개 문구를 작성해 주세요.'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.campaign_description) || isFieldEmpty(campaign.campaign_description_c)"
                                                trim
                                                />
                                            <div v-if="description_preview === true"
                                                class="mb-2 py-3 px-3 bgray-200 rounded"
                                                v-html="isFieldEmpty(temp_campaign.campaign_description_c) ? '(없음)' : temp_campaign.campaign_description_c"
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" class="text-right">
                                        <p class="text-danger font-weight-normal">※ 평가 소개 문구에 html 태그를 사용할 수 있습니다.</p>
                                    </b-col>
                                    <b-col cols="12" class="text-right">
                                        <b-btn
                                            variant="dark-border"
                                            size="sm"
                                            class="mr-2"
                                            @click="initializeCampaignTranslation('campaign_description')"
                                            :disabled="getGlobalDisabledCampaignEdit || value_new || isFieldEmpty(campaign.campaign_description)"
                                            >
                                            평가소개 문구 - 번역 초기화
                                        </b-btn>
                                        <b-btn variant="dark-border"
                                            size="sm"
                                            @click="description_preview = !description_preview"
                                            :disabled="getGlobalDisabledCampaignEdit"
                                            >
                                            {{ description_preview !== true ? '미리보기' : '수정' }}
                                        </b-btn>
                                    </b-col>
                                </b-form-row>
                                <b-form-row class="mb-3">
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-policy_content"
                                            label="사전 동의 사항"
                                            label-for="input-campaign-policy_content"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-textarea
                                                id="input-campaign-policy_content"
                                                v-model="temp_campaign.policy_content"
                                                @input="editCampaign('policy_content')"
                                                rows="8"
                                                class="mb-2"
                                                placeholder="정보 수집 및 제3자 정보 제공 등과 관련하여 사전 동의가 필요한 사항에 대해 작성하여 주십시오. 작성 후 우측 하단의 미리보기를 통해 확인 가능합니다."
                                                :disabled="getGlobalDisabledCampaignEdit"
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-policy_content-e"
                                            label="(영문) 사전 동의 사항"
                                            label-for="input-campaign-policy_content-e"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-textarea
                                                id="input-campaign-policy_content-e"
                                                v-model="temp_campaign.policy_content_e"
                                                @input="editCampaign('policy_content_e')"
                                                rows="8"
                                                class="mb-2"
                                                :placeholder="!campaign.policy_content_e ? '번역된 영/중문이 있을시 수정 가능' : '정보 수집 및 제3자 정보 제공 등과 관련하여 사전 동의가 필요한 사항에 대해 작성하여 주십시오. 작성 후 우측 하단의 미리보기를 통해 확인 가능합니다.'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.policy_content) || isFieldEmpty(campaign.policy_content_e)"
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <b-form-group
                                            id="input-group-campaign-policy_content-c"
                                            label="(중문) 사전 동의 사항"
                                            label-for="input-campaign-policy_content-c"
                                            label-class="fw-500 f-110"
                                            >
                                            <b-textarea
                                                id="input-campaign-policy_content-c"
                                                v-model="temp_campaign.policy_content_c"
                                                @input="editCampaign('policy_content_c')"
                                                rows="8"
                                                class="mb-2"
                                                :placeholder="!campaign.policy_content_c ? '번역된 영/중문이 있을시 수정 가능' : '정보 수집 및 제3자 정보 제공 등과 관련하여 사전 동의가 필요한 사항에 대해 작성하여 주십시오. 작성 후 우측 하단의 미리보기를 통해 확인 가능합니다.'"
                                                :disabled="getGlobalDisabledCampaignEdit || isFieldEmpty(campaign.policy_content) || isFieldEmpty(campaign.policy_content_c)"
                                                trim
                                                />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" class="text-right">
                                        <b-btn
                                            variant="dark-border"
                                            size="sm"
                                            class="mr-2"
                                            @click="initializeCampaignTranslation('policy_content')"
                                            :disabled="getGlobalDisabledCampaignEdit || value_new || isFieldEmpty(campaign.policy_content)"
                                            >
                                            사전 동의사항 - 번역 초기화
                                        </b-btn>
                                        <b-btn
                                            variant="dark-border"
                                            size="sm"
                                            @click="showPolicyPreview"
                                            :disabled="getGlobalDisabledCampaignEdit"
                                            >
                                            미리보기
                                        </b-btn>
                                    </b-col>
                                </b-form-row>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" offset-md="3" md="9">
                                <hr class="border-top-0 border-bottom border-color-gray-700 pt-3 mb-5">
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="3">
                                <h4>평가 컨텐츠</h4>
                            </b-col>
                            <b-col cols="12" md="9">
                                <b-form-row class="align-items-center">
                                    <b-col cols="2" class="fw-500 f-110">
                                        질문지
                                    </b-col>
                                    <b-col col>
                                        <b-dropdown
                                            id="input-campaign-questionnaire"
                                            boundary="viewport"
                                            variant="dark-border"
                                            class="w-100"
                                            :text="selected_template.template_name"
                                            :disabled="getGlobalDisabledCampaignEdit"
                                            >
                                            <!-- :text="!templates.length ? '1. 필수요소에서 [평가 산업] 을 먼저 선택해주세요' : selected_template.template_name" -->
                                            <div style="max-height:50vh; overflow: auto">
                                                <b-dropdown-item-button v-for="item in templates"
                                                    :key="item.id"
                                                    @click="selectTemplate(item)"
                                                    >
                                                    {{item.template_id }}. {{ item.template_name }}
                                                </b-dropdown-item-button>
                                            </div>
                                        </b-dropdown>
                                    </b-col>
                                </b-form-row>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" offset-md="3" md="9">
                                <hr class="border-top-0 border-bottom border-color-gray-700 pt-3 mb-5">
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12" md="3">
                                <h4>저장</h4>
                            </b-col>
                            <b-col cols="12" md="3">
                                <b-btn
                                    type="submit"
                                    class="mb-3 mb-md-0"
                                    :variant="is_saving_campaign === true ? 'green' : 'blue'"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_edited_campaign"
                                    size="lg"
                                    block
                                    >
                                    <span v-show="is_saving_campaign">
                                        <b-spinner class="mx-2 p-1 my-1" small type="grow"></b-spinner> 저장 중입니다.
                                    </span>
                                    <span v-show="!is_saving_campaign">
                                        평가 저장하기 <fa icon="save" class="ml-2"></fa>
                                    </span>
                                </b-btn>
                            </b-col>
                            <b-col cols="12" md="3">
                                <b-btn
                                    variant="danger"
                                    class="mb-3 mb-md-0"
                                    size="lg"
                                    @click="resetCampaign"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_edited_campaign"
                                    block
                                    >
                                    되돌리기
                                </b-btn>
                            </b-col>
                            <b-col cols="12" md="3">
                                <b-btn
                                    size="lg"
                                    @click="initializeCampaignTranslation(null)"
                                    :disabled="getGlobalDisabledCampaignEdit || !is_able_to_translation_intial"
                                    block
                                    >
                                    전체 번역 초기화

                                    <b-spinner v-show="is_initializing_campaign_translation" class="mr-1" />
                                </b-btn>
                            </b-col>
                        </b-form-row>
                    </b-form>

                    <div class="text-right">
                        <b-button
                            class="mt-5 f-110"
                            @click.stop="pageGo({name: 'CampaignList'})"
                            :disabled="getGlobalDisabledCampaignEdit"
                            >
                            목록으로
                        </b-button>
                    </div>
                </b-col>
            </b-row>

            <b-modal
                id="hj-agree"
                title="사전 동의 사항 미리보기"
                scrollable hide-footer hide-header-close no-close-on-backdrop no-close-on-esc
                size="lg"
                >
                <div class="mb-2 border-bottom border-color-gray-400 pb-4 mb-3">
                    <h6 class="mb-2 gray-500">(국문)</h6>
                    <div class="bgray-300 rounded overflow-auto p-3"
                        v-html="!temp_campaign.policy_content ? '(없음)' : temp_campaign.policy_content"
                        style="max-height:400px;"
                        />
                </div>
                <div class="mb-2 border-bottom border-color-gray-400 pb-4 mb-3">
                    <h6 class="mb-2 gray-500">(영문)</h6>
                    <div class="bgray-300 rounded overflow-auto p-3"
                        v-html="!temp_campaign.policy_content_e ? '(없음)' : temp_campaign.policy_content_e"
                        style="max-height:400px;"
                        />
                </div>
                <div class="mb-2">
                    <h6 class="mb-2 gray-500">(중문)</h6>
                    <div class="bgray-300 rounded overflow-auto p-3"
                        v-html="!temp_campaign.policy_content_c ? '(없음)' : temp_campaign.policy_content_c"
                        style="max-height:400px;"
                        />
                </div>
                <hr>
                <h6 class="mt-4 mb-4 text-center">위 내용에 동의하십니까?</h6>
                <b-form-radio-group class="mb-4 text-center" v-model="fake_policy_agree">
                    <b-form-radio value="Y">예, 동의합니다.</b-form-radio>
                    <b-form-radio value="N">아니오, 동의하지 않습니다.</b-form-radio>
                </b-form-radio-group>
                <div class="text-right blue">확인을 누르면 미리보기가 종료됩니다. <b-button @click="hidePolicyPreview" variant="blue" class="ml-3">확인</b-button> </div>
            </b-modal>

        </b-container>
    </div>
</template>


<script>
// import CompanyFinder from '@/components/managing_user/CompanyFinder'
// import EditingPortfolio from '@/components/managing_portfolio/EditingPortfolio'
// import EditingCampaignUsers from '@/components/managing_campaigns/campaign_subs/EditingCampaignUsers'
import { debounce } from 'lodash';
import * as ih from '@core_utils/util'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'editing-campaign-attr',
    props: {
        // value_new: { type: Boolean, default: false }, prop 인지 기능에 문제가 생겨 created에서 임시 처리함
    },
    components:{
        // CompanyFinder,
        // EditingPortfolio,
        // EditingCampaignUsers,
    },
    data () {
        return {
            temp_campaign: {},
            templates: [],
            selected_template: {
                template_name: '질문지 선택',
                template_code: '',
                template_contents: [],
                template_id: ''
            },
            template_code:'',
            portfolios: [],
            selected_portfolio: {
                portfolio_name: '참여대상 리스트 선택',
                portfolio_id: '',
                portfolio_description: '',
                portfolio_target_companies: []
            },
            target_companies:[],

            historic_mode: false, 
            all_campaigns: [],
            selected_campaign: {
                campaign_id: null,
                campaign_name: '지난 평가 선택'
            },
            target_auditor: null,
            selected_auditors: [],
            description_preview:false,
            policy_preview: false,

            fake_policy_agree: '',
            is_saving_campaign: false,
            is_initializing_campaign_translation: false,
            is_edited_campaign: false,
            is_loading_portfolio: false,
            save_excludes: false, //신규 평가 저장 후 excluded users 저장

            selected_period: null,
            period_options: [
                // { value: '2021_1H', text: '2021 - 1회차' },
                // { value: '2021_2H', text: '2021 - 2회차' },
                // { value: '2022_1H', text: '2022 - 1회차' },
                // { value: '2022_2H', text: '2022 - 2회차' },
                // { value: '2023_1H', text: '2023 - 1회차' },
                // { value: '2023_2H', text: '2023 - 2회차' },
                { value: '2024_1H', text: '2024 - 1회차' },
                { value: '2024_2H', text: '2024 - 2회차' },
                { value: '2025_1H', text: '2025 - 1회차' },
                { value: '2025_2H', text: '2025 - 2회차' },
                { value: '2026_1H', text: '2026 - 1회차' },
                { value: '2026_2H', text: '2026 - 2회차' },
                { value: '2027_1H', text: '2027 - 1회차' }
            ],
            selected_industry: null,
            industry_options: []
        }
    },
    computed: {
        ...mapState('auditors', {
            admin_user_space: state => state.admin_user_space,
            is_admin_space_loaded: state => state.is_admin_space_loaded
        }),
        ...mapState(['user_name', 'company_name','campaign_id', 'e_mail', 'user_id', 'portfolio', 'campaign', 'selected_company' ]),
        ...mapState('industry_campaigns', ['industries', 'campaigns']),
        getGlobalDisabledCampaignEdit () {
            return this.is_initializing_campaign_translation || this.is_saving_campaign
        },
        isAuthenticated () {
            return this.$store.getters.isAuthenticated
        },
        isLoggedIn () {
            return this.$store.getters.isLoggedIn
        },
        start_date () {
            // 평가 기간 및 회차 선택 정보에 따라서 고정날짜 return
            if (this.selected_period === '2021_1H') {
                return '2021-03-01'
            } else if (this.selected_period === '2021_2H') {
                return '2021-10-12'
            } else if (this.selected_period === '2022_1H') {
                return '2022-04-01'
            } else if (this.selected_period === '2022_2H') {
                return '2022-10-11'
            } else if (this.selected_period === '2023_1H') {
                return '2023-04-01'
            } else if (this.selected_period === '2023_2H') {
                return '2023-10-01'
            } else if (this.selected_period === '2024_1H') {
                return '2024-04-01'
            } else if (this.selected_period === '2024_2H') {
                return '2024-10-01'
            } else {
                return '미선택'
            }
            
        },
        end_date () {
            // 평가 기간 및 회차 선택 정보에 따라서 고정날짜 return
            if (this.selected_period === '2021_1H') {
                return '2021-06-30'
            } else if (this.selected_period === '2021_2H') {
                return '2022-03-31'
            } else if (this.selected_period === '2022_1H') {
                return '2022-09-30'
            } else if (this.selected_period === '2022_2H') {
                return '2023-03-31'
            } else if (this.selected_period === '2023_1H') {
                return '2023-09-30'
            } else if (this.selected_period === '2023_2H') {
                return '2024-03-31'
            } else if (this.selected_period === '2024_1H') {
                return '2024-09-30'
            } else if (this.selected_period === '2024_2H') {
                return '2025-03-31'
            } else {
                return '미선택'
            }
        },
        target_year () {
            // 평가 기간 및 회차 선택 정보에 따라서 고정날짜 return
            if (!this.selected_period) {
                return null
            } else {
                let _year = Number(this.selected_period.split('_')[0])
                const _target_year = _year - 1
                return `FY${_target_year}`
            }
        },
        value_new () {
            return typeof this.$route.query.value_new === 'undefined'
                ? false
                : JSON.parse(this.$route.query.value_new)
        },
        is_able_to_translation_intial () {
            return !this.value_new || (!this.isFieldEmpty(this.campaign.campaign_name) || !this.isFieldEmpty(this.campaign.campaign_description) || !this.isFieldEmpty(this.campaign.policy_content))
        }
    },
    watch: {
        industries: {
            immediate: true,
            handler (val) {
                if (val) {
                    this.industry_options = val.reduce((_industry_options, _option) => {
                        _industry_options.push({ value: _option.code, text: _option.code +', '+ _option.industry_name })
                        return _industry_options
                    }, [])
                }
            }
        },
        campaign: {
            handler (_updated_campaign) {
                if (_updated_campaign) {
                    this.temp_campaign = ih.deepCopy(_updated_campaign)
                    this.is_saving_campaign = false
                    this.is_edited_campaign = false
                    this.is_initializing_campaign_translation = false
                    this.is_loading_portfolio = false
                }
            }
        }
    },
    async created() {   
        await this.readAllIndustries(this.user_id)

        if (this.value_new === true) { 
            this.temp_campaign = ih.deepCopy(this.campaign)
            this.readTemplateList()
        }
        else { 
            await this.setCampaign()
        }
    },
    mounted () {
        if (this.industries.length > 0 & this.campaign.industry_id) {
            let idx = this.industries.findIndex(x => x.industry_id == this.campaign.industry_id)
            if (idx > -1) {
                this.selected_industry = this.industries[idx].code
            }
        }
    },
    beforeDestroy () {
        this.fake_policy_agree = ''
        this.is_saving_campaign = false
        this.is_edited_campaign = false
        this.is_initializing_campaign_translation = false
        this.is_loading_portfolio = false
        this.$store.commit('update_campaign', null)
    },
    methods: {
        ...mapActions('industry_campaigns', ['readAllIndustries']),
        async setCampaign () {
            this.temp_campaign = ih.deepCopy(this.campaign) // 캠페인 편집/업데이트할 경우 
            this.selected_period = this.temp_campaign.period
            this.selected_portfolio.portfolio_target_companies = ih.deepCopy(this.campaign.campaign_target_companies)

            this.$store.commit('update_portfolio', this.selected_portfolio)
            await this.readTemplateList()

            let idx = this.templates.findIndex(item => item.template_code == this.campaign.template_code)
            if(idx > -1) { 
                this.selected_template = this.templates[idx] 
            }

            // this.campaign.auditors.forEach(info => {
            //     let idx = this.admin_user_space.findIndex(item => item.id == info.auditor_id)
            //     if(idx > -1){
            //         let auditor_obj = this.admin_user_space[idx]
            //         this.selected_auditors.push(auditor_obj)
            //     }
            // })

            if (this.industries.length > 0) {
                let _campanign_industry_idx = this.industries.findIndex(x => x.industry_id == this.campaign.industry_id)
                if (_campanign_industry_idx > -1) {
                    this.selected_industry = this.industries[_campanign_industry_idx].code
                }
            }

            if (this.campaign.previous_campaign_id !== null && this.campaign.previous_campaign_id !== 0) {
                let idx = this.campaigns.findIndex(item => item.campaign_id == this.campaign.previous_campaign_id )
                if(idx >-1){
                    this.historic_mode = true
                    this.selectPreviousCampaign(this.campaigns[idx])
                }
            }
        },
        async readTemplateList () {
            try {
                const response = await this.$axios.get('/read_template_list', {
                    params: { user_id: this.user_id, mode: 'qesg_assessment' }
                })
                let result = response.data.templates
                this.templates = []
                
                for (var i = 0; i < result.length; i++) {
                    const {
                        template_id, template_name, template_code, template_contents,
                        campaign_name, campaign_state,
                        user_id, type, time_stamp
                    } = result[i]

                    this.templates.push({
                        template_id, template_name, template_code,
                        template_contents: template_contents !== '' ? JSON.parse(template_contents) : [],
                        campaign_name, campaign_state,
                        type, time_stamp, user_id
                    })
                }
            } catch (error) {
                if (error.status == '401') {
                    alert(this.$t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
                    this.$store.dispatch('logout').then(() => { this.$router.push({name:'Login'}) })
                }
            }
        },
        async initializeCampaignTranslation (field) {
            try {
                /**
                 * field = [null === 'total'| 'campaign_name' | 'campaign_description' | 'policy_content']
                 */
                
                this.is_initializing_campaign_translation = true
                const formData = new FormData()
                if (!field) {
                    formData.append('campaign_name', null)
                    formData.append('campaign_description', null)
                    formData.append('policy_content', null)
                } else {
                    formData.append(field, null)
                }

                const _res_saved_campaign = await this.$axios.post(`/translate/initial/campaign/${this.campaign.campaign_id}`, formData)
                this.$store.commit('update_campaign', _res_saved_campaign.data)
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        alert(this.$t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
                        await this.$store.dispatch('logout')
                        this.$router.push({name:'Login'})
                    }
                }
            } finally {
                this.is_initializing_campaign_translation = false
            }
        }, 
        async handleSaveCampaign () {
            try {
                if (this.checkForm() === true) {
                    this.is_saving_campaign = true

                    let new_campaign = {
                        user_id: this.user_id,
                        campaign_id: 0,
                        campaign_name: this.temp_campaign.campaign_name,
                        campaign_description: this.temp_campaign.campaign_description,
                        template_code: this.temp_campaign.template_code,
                        period: this.selected_period,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        target_year: this.target_year,
                        campaign_type: 'qesg_assessment',
                        campaign_state: '생성/편집',
                        // campaign_target_companies_id: temp_arr,
                        previous_campaign_id: this.selected_campaign.campaign_id,
                        auditors: this.selected_auditors.map(x => x.id),
                        policy_content: this.temp_campaign.policy_content,
                        industry_code: this.selected_industry,
                        steps: null,
                        process_options: this.temp_campaign.process_options,
                        operator_name: null,
                        is_public: null,
                        required_info: null,
                    }

                    if (this.value_new !== true) {
                        const {
                            template_code, campaign_id, user_id, campaign_state,
                            campaign_name, campaign_name_e, campaign_name_c,
                            campaign_description, campaign_description_e, campaign_description_c,
                            policy_content, policy_content_e, policy_content_c
                        } = this.temp_campaign

                        new_campaign = {
                            ...new_campaign,
                            template_code, campaign_id, user_id, campaign_state,
                            campaign_name, campaign_name_e, campaign_name_c,
                            campaign_description, campaign_description_e, campaign_description_c,
                            policy_content, policy_content_e, policy_content_c,
                        }

                        new_campaign.period = this.selected_period,
                        new_campaign.start_date = this.start_date,
                        new_campaign.end_date = this.end_date,
                        new_campaign.industry_code = this.selected_industry
                    }

                    if (this.historic_mode === false) {
                        new_campaign.previous_campaign_id = null
                    }

                    // 편집유무 확인
                    if (this.is_edited_campaign) {
                        // 신규 캠페인시 일반 저장
                        if (this.value_new || new_campaign.template_code !== this.selected_template.template_code) {
                            if (new_campaign.template_code !== this.selected_template.template_code) {
                                new_campaign.template_code = this.selected_template.template_code
                            }

                            await this.$store.dispatch('saveCampaign', new_campaign)
                        } else {
                            // 기존 캠페인시 처리 분개
                            const campaignForm = {
                                _kr_field: ['campaign_name' ,'selected_period' ,'campaign_description' ,'policy_content'],
                                _eng_field: ['campaign_name_e', 'campaign_name_c', 'campaign_description_e', 'campaign_description_c', 'policy_content_e', 'policy_content_c']
                            }

                            // 한/영중문 편집 유무 확인
                            const _is_edited_kr_formField = campaignForm._kr_field.reduce((_isEditedKR, fieldName) => {
                                _isEditedKR = _isEditedKR || this.temp_campaign[fieldName] !== this.campaign[fieldName]
                                return _isEditedKR
                            }, false)

                            const _is_edited_eng_formField = campaignForm._eng_field.reduce((_isEditedENG, fieldName) => {
                                _isEditedENG = _isEditedENG || this.temp_campaign[fieldName] !== this.campaign[fieldName]
                                return _isEditedENG
                            }, false)

                            // 한국어 편집시 기본 저장
                            if (_is_edited_kr_formField) {
                                await this.$store.dispatch('saveCampaign', new_campaign)
                            } else if (!_is_edited_kr_formField && _is_edited_eng_formField) {
                                // 한국어 미편집 && 영중문 편집시 /translate/campaign/campaign_id 에 저장
                                const _edited_translation_formData = new FormData()
                        
                                if (this.temp_campaign.campaign_name_e !== this.campaign.campaign_name_e) {
                                    _edited_translation_formData.append('campaign_name_e', this.temp_campaign.campaign_name_e)
                                }

                                if (this.temp_campaign.campaign_name_c !== this.campaign.campaign_name_c) {
                                    _edited_translation_formData.append('campaign_name_c', this.temp_campaign.campaign_name_c)
                                }

                                if (this.temp_campaign.campaign_description_e !== this.campaign.campaign_description_e) {
                                    _edited_translation_formData.append('campaign_description_e', this.temp_campaign.campaign_description_e)
                                }

                                if (this.temp_campaign.campaign_description_c !== this.campaign.campaign_description_c) {
                                    _edited_translation_formData.append('campaign_description_c', this.temp_campaign.campaign_description_c)
                                }

                                if (this.temp_campaign.policy_content_e !== this.campaign.policy_content_e) {
                                    _edited_translation_formData.append('policy_content_e', this.temp_campaign.policy_content_e)
                                }

                                if (this.temp_campaign.policy_content_c !== this.campaign.policy_content_c) {
                                    _edited_translation_formData.append('policy_content_c', this.temp_campaign.policy_content_c)
                                }

                                const res_translate_campaign = await this.$axios.post(`/translate/campaign/${this.campaign.campaign_id}`, _edited_translation_formData)
                                this.$store.commit('update_campaign', res_translate_campaign.data)
                            }
                        }
                    }

                    await this.setCampaign()
                    this.save_excludes = true
                    this.$EventBus.$emit('toast-success', '저장완료', '평가 캠페인을 저장하였습니다.')
                    
                    if (this.$route.query.value_new && this.campaign.campaign_id) {
                        this.$router.replace({ query: { value_new: false, campaign_id: this.campaign.campaign_id } })
                    }
                }   
            } catch (error) {
                this.common_error_handling(error)
            } finally {
                this.is_saving_campaign = false
            }
        },
        editCampaign: debounce(function (fieldname) {
            if (fieldname === 'selected_period') {
                this.is_edited_campaign = this.campaign.period !== this.selected_period
            } else if (fieldname === 'selected_industry') {
                const _selected_industry_index = this.industry_options.findIndex(({ value }) => value === this.selected_industry)
                if (_selected_industry_index > -1) {
                    this.is_edited_campaign = this.campaign.industry_id !== Number(_selected_industry_index) + 1
                } else {
                    this.is_edited_campaign = false
                }
            } else if (fieldname === 'process_options') {
                const _sorted_temp_campaign_process_options = [ ...this.temp_campaign.process_options ].sort(),
                    _sorted_campaign_process_options = [ ...this.campaign.process_options ].sort()
                    this.is_edited_campaign = _sorted_temp_campaign_process_options.length !== _sorted_campaign_process_options.length
                        || _sorted_temp_campaign_process_options.toString() !== _sorted_campaign_process_options.toString()
            } else {
                this.is_edited_campaign = this.campaign[fieldname] !== this.temp_campaign[fieldname]
            }
        }, 300),
        checkForm(){
            if (this.temp_campaign.campaign_name=='') {
                alert('평가명을 입력해 주세요')
                return false
            } else {
                return true
            }
        },
        selectTemplate (template) {
            this.is_edited_campaign = this.campaign.template_code !== template.template_code
            this.selected_template = template
        },
        pageGo(destination){
            this.$store.commit('update_now_page', destination.name)
            this.$router.push(destination)
        },
        selectPreviousCampaign(campaign){
            this.selected_campaign = campaign
        },
        auditorAdd (target_auditor) {
            let target_e_mail = target_auditor.split(' ', 1)[0] //e-mail
            if(target_e_mail == this.e_mail){
                return false
            }
            let idx = this.selected_auditors.findIndex(item => item.e_mail == target_e_mail)
            if (idx > -1) { return false }
            else {
                let auditor_obj = this.admin_user_space.findIndex(item => item.e_mail == target_e_mail)
                if( auditor_obj > -1 ){
                    this.selected_auditors.push(this.admin_user_space[auditor_obj])
                }
            }
        },
        deleteSelectedAuditor(target_e_mail){
            let idx = this.selected_auditors.findIndex(item=> item.e_mail == target_e_mail )
            if( idx > -1){
                this.selected_auditors.splice(idx,1)
            }
        },
        showPolicyPreview(){
            this.policy_preview =true
            this.$bvModal.show('hj-agree')
        },
        hidePolicyPreview(){
            this.policy_preview =false
            this.$bvModal.hide('hj-agree')
        },
        resetCampaign () {
            this.setCampaign()
            this.is_saving_campaign = false
            this.is_edited_campaign = false
            this.is_initializing_campaign_translation = false
            this.is_loading_portfolio = false

            this.selected_template = {
                template_name: '질문지 선택',
                template_code: '',
                template_contents: [],
                template_id: ''
            }
        },
        moveToCampaignListPage () {
            if (this.is_edited_campaign) {
                const _is_move_campaign_list_page = confirm('저장되지 않은 수정내용이 있습니다. 캠페인 목록 페이지로 이동하시겠습니까?')
                if (_is_move_campaign_list_page) {
                    this.$router.push({ name: 'CampaignList' })
                } else {
                    return false
                }
            } else {
                this.$router.push({ name: 'CampaignList' })
            }
        }
    }
}
</script>
<style>
</style>
